import type * as SchemaTypes from '../../../apolloClient.types';

import type { SubgroupListItemDataFragment } from '../GroupListing/GroupList.api';
import { gql } from '@apollo/client';
import { SubgroupListItemDataFragmentDoc } from '../GroupListing/GroupList.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSubgroupMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.CreateSubgroupInput;
}>;


export type CreateSubgroupMutation = (
  { __typename: 'Mutation' }
  & { createSubgroup: (
    { __typename: 'CreateSubgroupSuccessfulResponse' }
    & { result: (
      { __typename: 'Subgroup' }
      & SubgroupListItemDataFragment
    ) }
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);


export const CreateSubgroupDocument = /*#__PURE__*/ gql`
    mutation CreateSubgroup($input: CreateSubgroupInput!) {
  createSubgroup(input: $input) {
    __typename
    ... on CreateSubgroupSuccessfulResponse {
      result {
        ...SubgroupListItemData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SubgroupListItemDataFragmentDoc}`;
export type CreateSubgroupMutationFn = Apollo.MutationFunction<CreateSubgroupMutation, CreateSubgroupMutationVariables>;

/**
 * __useCreateSubgroupMutation__
 *
 * To run a mutation, you first call `useCreateSubgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubgroupMutation, { data, loading, error }] = useCreateSubgroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubgroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubgroupMutation, CreateSubgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubgroupMutation, CreateSubgroupMutationVariables>(CreateSubgroupDocument, options);
      }
export type CreateSubgroupMutationHookResult = ReturnType<typeof useCreateSubgroupMutation>;
export type CreateSubgroupMutationResult = Apollo.MutationResult<CreateSubgroupMutation>;
export type CreateSubgroupMutationOptions = Apollo.BaseMutationOptions<CreateSubgroupMutation, CreateSubgroupMutationVariables>;